export default "__VITE_ASSET__CfsAOgrC__"